









































































import {
  Vue, Prop, Component, Emit,
} from 'vue-property-decorator';
import Dropdown from '@/shared/dropdown/dropdown.component.vue';
import ModalConfirm from '@/shared/modals/modal-confirm.component.vue';
import ProjectDirectivePersist from '@/domain/directives/project-directive-persist.entity';
import DirectiveDefinition from '../../domain/directives/directive-definition.entity';

@Component({
  components: {
    'dropdown-component': Dropdown,
    'modal-confirm': ModalConfirm,
  },
})
export default class DirectivesConfigCard extends Vue {
  @Prop()
  directives!: DirectiveDefinition[];

  @Prop()
  defaultDirectives!: DirectiveDefinition[];

  @Prop()
  loading!: boolean;

  private confirmDialog: boolean = false;

  private decoyDirective: any = {};

  private selectDirective(directive: any, option: any) {
    if (this.doesItContainADivergingProp(directive) && directive.diverging) {
      this.confirmDialog = true;
      this.decoyDirective = { directive, option };
    } else {
      this.emitSelectDirectiveEvent(directive, option);
    }
  }

  private emitSelectDirectiveEvent(directive: any, option: any) {
    const processedOption: any = this.processOption(directive, option);
    this.$emit('selectDirective', processedOption);
  }

  private confirm() {
    this.emitSelectDirectiveEvent(this.decoyDirective.directive, this.decoyDirective.option);
    this.confirmDialog = false;
  }

  private cancel() {
    this.$emit('clickCancelModal');
    this.confirmDialog = false;
  }

  private doesItContainADivergingProp(directive: any) {
    return Object.prototype.hasOwnProperty.call(directive, 'diverging');
  }

  private processOption(directive: any, option: any) {
    const str: string = option.toLowerCase();

    directive.inheritance = str.includes('inherited') === true;
    directive.activated = str.startsWith('y') === true;

    if (this.doesItContainADivergingProp(directive)) {
      directive.diverging = false;
      return directive;
    }

    return new ProjectDirectivePersist(directive);
  }

  private defaultSelectedValue(directive: any) {
    if (directive.diverging) return '';
    if (directive.inheritance) return directive.options[2];
    return directive.activated === true ? directive.options[0] : directive.options[1];
  }

  private mapDefaultOptionsForEveryDirective() {
    this.directives.forEach((directive: any) => {
      directive.options = ['Yes', 'No'];
      const matchingDefaultDirective: any = this.getMatchingDefaultDirective(directive);
      const newOption: any = matchingDefaultDirective.activated === true ? 'Yes (inherited)' : 'No (inherited)';
      directive.options.push(newOption);
    });
  }

  private getMatchingDefaultDirective(directive: any) {
    return this.defaultDirectives.find(
      (item: any) => item.directive.name === directive.directive.name,
    );
  }

  private get isTheDirectivesListBigEnough() {
    return this.directives.length > 6;
  }

  beforeUpdate() {
    this.mapDefaultOptionsForEveryDirective();
  }
}
